const filters = [
  {
    fieldName: 'campaignName',
    displayName: 'Campaign',
    isHidden: false,
    roles: ['admin', 'affiliate', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: true,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'campaignId',
    displayName: 'Campaign Id',
    isHidden: true,
    roles: ['admin', 'affiliate', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'affiliateName',
    displayName: 'Affiliate',
    isHidden: false,
    roles: ['admin', 'affiliate', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: true,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'affiliateId',
    displayName: 'Affiliate Id',
    isHidden: true,
    roles: ['admin', 'affiliate', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'numberPoolName',
    displayName: 'Pool',
    isHidden: false,
    roles: ['admin', 'affiliate', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: true,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'numberPoolId',
    displayName: 'Pool Id',
    isHidden: true,
    roles: ['admin', 'affiliate', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'inboundPhoneNumber',
    displayName: 'Inbound #',
    isHidden: false,
    roles: ['admin', 'affiliate', 'buyer', 'user'],
    scubbers: '',
    fieldType: 'phone',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'inboundCallId',
    displayName: 'Inbound Id',
    isHidden: true,
    roles: ['admin', 'affiliate', 'buyer', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'number',
    displayName: 'Dialed #',
    isHidden: false,
    roles: ['admin', 'affiliate', 'user'],
    scubbers: '',
    fieldType: 'phone',
    isGroupable: true,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'timeToCallInSeconds',
    displayName: 'Time To Call',
    displayNameShort: 'TtC',
    isHidden: false,
    roles: ['admin', 'affiliate', 'buyer', 'user'],
    scubbers: 'positive',
    fieldType: 'seconds',
    isGroupable: false,
    isSearchable: true,
    isRange: true,
    isCalculated: false
  },
  {
    fieldName: 'accountId',
    displayName: 'Account Id',
    isHidden: true,
    roles: ['admin', 'affiliate', 'buyer', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'previouseCallCallId',
    displayName: 'Duplicate',
    isHidden: false,
    roles: ['admin', 'affiliate', 'user'],
    scubbers: 'hasValue',
    fieldType: 'bool',
    isGroupable: true,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'previouseCallTargetName',
    displayName: 'Previous Target',
    isHidden: true,
    roles: ['admin', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'url',
    displayName: 'Url',
    isHidden: false,
    roles: ['admin', 'user'],
    scubbers: '',
    fieldType: 'string',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'failReason',
    displayName: 'Failed',
    isHidden: false,
    roles: ['admin', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'recordingUrl',
    displayName: 'Url',
    isHidden: false,
    roles: ['admin', 'user'],
    scubbers: '',
    fieldType: 'string',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'source',
    displayName: 'Hangup',
    isHidden: false,
    roles: ['admin', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'timeToConnect',
    displayName: 'Time to Connect',
    isHidden: false,
    roles: ['admin', 'affiliate', 'buyer', 'user'],
    scubbers: 'positive',
    fieldType: 'seconds',
    isGroupable: false,
    isSearchable: true,
    isRange: true,
    isCalculated: false
  },
  {
    fieldName: 'targetName',
    displayName: 'Target Name',
    isHidden: false,
    roles: ['admin', 'buyer', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: true,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'targetId',
    displayName: 'Target Id',
    isHidden: true,
    roles: ['admin', 'buyer', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'targetBuyerId',
    displayName: 'Buyer Id',
    isHidden: true,
    roles: ['admin', 'buyer', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'targetBuyer',
    displayName: 'Buyer',
    isHidden: true,
    roles: ['admin', 'buyer', 'user'],
    scubbers: '',
    fieldType: 'text',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  },
  {
    fieldName: 'conversionAmount',
    displayName: 'Conversion Amount',
    isHidden: false,
    roles: ['admin', 'buyer', 'user'],
    scubbers: '',
    fieldType: 'currency',
    isGroupable: false,
    isSearchable: true,
    isRange: true,
    isCalculated: false
  },
  {
    fieldName: 'payoutAmount',
    displayName: 'Payout',
    isHidden: false,
    roles: ['admin', 'affiliate', 'user'],
    scubbers: '',
    fieldType: 'currency',
    isGroupable: false,
    isSearchable: true,
    isRange: true,
    isCalculated: false
  },
  {
    fieldName: 'callLengthInSeconds',
    displayName: 'Call Length',
    isHidden: false,
    roles: ['admin', 'affiliate', 'buyer', 'user'],
    scubbers: 'positive',
    fieldType: 'seconds',
    isGroupable: false,
    isSearchable: true,
    isRange: true,
    isCalculated: false
  },
  {
    fieldName: 'stepName',
    displayName: 'Step Name',
    isHidden: false,
    roles: ['admin', 'user'],
    scubbers: '',
    fieldType: 'string',
    isGroupable: false,
    isSearchable: true,
    isRange: false,
    isCalculated: false
  }
];

const filterToTagTypeMapping = {
  campaignName: 'Campaign',
  campaignId: 'Campaign',
  affiliateId: 'Publisher',
  affiliateName: 'Publisher'
};

function normalizeFiltersForTagSelector(filters) {
  let tags = [];
  for (let filter of filters) {
    tags.push(getNormalizedFilter(filter));
  }

  return tags;
}

function getNormalizedFilter(filter) {
  return {
    tagName: filter.displayName,
    tagType: filterToTagTypeMapping[filter.fieldName] || 'Others',
    tagSource: 'Filters',
    isRange: filter.isRange,
    fieldType: filter.fieldType,
    fieldName: filter.fieldName
  };
}

const reportingTags = [
  'InboundNumber',
  'Date',
  'Publisher',
  'Time',
  'Campaign',
  'CallLength',
  'DialedNumber',
  'Address',
  'Verification & Scoring',
  'Demographics',
  'Property Construction',
  'Property Information',
  'Alternate Phone Numbers',
  'Automotive',
  'Property Location',
  'Mortgage',
  'Property Deed Assessment',
  'Lifestyle Interests',
  'Email Addresses',
  'Identity',
  'Property Prior Sale',
  'Caller Profile',
  'Financial',
  'CallInfo',
  'Gather',
  'gather'
];

const reportingTagsMapping = {
  Campaign: ['Id', 'Name', 'TrackingId'],
  Identity: ['Last Name', 'First Name', 'Middle Name'],
  Publisher: ['Company', 'Id', 'SubId', 'Name', 'ReplacementNumber']
};

function getNormalizedTag(tag, tagType) {
  return {
    tagName: tag,
    tagType: tagType || '',
    tagSource: 'Tags'
  };
}

function normalizeTagsForTagSelector(tags) {
  let transformedTags = [];
  for (let tag of tags) {
    transformedTags = transformedTags.concat(getTagPropertiesFromMapping(tag));
  }

  return transformedTags;
}

function getTagPropertiesFromMapping(tag) {
  let properties = reportingTagsMapping[tag] || [];

  return properties.map(function mapTagProperties(property) {
    return getNormalizedTag(property, tag);
  });
}

export const getTagProperties = getTagPropertiesFromMapping;
export const normalizedTags = normalizeTagsForTagSelector(reportingTags);
export const normalizedFilters = normalizeFiltersForTagSelector(filters);
export const valuesForFilters = {
  campaignName: ['US Insurance', 'France Tech'],
  campaignId: ['camp1234', 'camp5678'],
  affiliateId: ['affil123', 'aff457'],
  affiliateName: ['Test pub', 'Test new pub']
};
